import logo from '../../images/unite_logo_no_bg.png';
import logoDark from '../../images/unite_logo_no_bg_dark.png';

export default function InitialVerificationLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center w-screen h-screen bg-white dark:bg-gray-1000">
      <div className="flex flex-col items-center justify-center max-w-md w-full px-8 -mt-12">
        {/* Logo */}
        <div className="mb-8">
          <img 
            src={logoDark} 
            alt="UNITE Logo" 
            className="max-w-xs md:max-w-sm lg:max-w-md w-full h-auto object-contain hidden dark:block"
          />
          <img 
            src={logo} 
            alt="UNITE Logo" 
            className="max-w-xs md:max-w-sm lg:max-w-md w-full h-auto object-contain dark:hidden"
          />
        </div>
        
        {/* Verification Message */}
        <div className="w-full mb-6 text-center">
          <div className="flex justify-center items-center mb-4">
            <div className="w-3 h-3 bg-[#fdb419] rounded-full mr-2 animate-pulse"></div>
            <span className="text-lg font-medium text-gray-700 dark:text-gray-300">
              Verifying User Access...
            </span>
          </div>
          
          {/* Animated Progress Indicator */}
          <div className="w-full bg-gray-200 rounded-full h-2 dark:bg-gray-700 shadow-inner overflow-hidden">
            <div className="bg-gradient-to-r from-[#fdb419] to-[#f59e0b] h-2 rounded-full animate-pulse">
              <div className="h-full w-full rounded-full bg-white opacity-20"></div>
            </div>
          </div>
          
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-4">
            Please wait while we verify your credentials...
          </p>
        </div>
      </div>
    </div>
  );
}
